export default __webpack_public_path__ + "static/media/blogpost1.f3f4c476.jpeg";